import { z } from 'zod'

// The list state (search term, pagination and sorting) lives in the URL so it
// survives a refresh, works with the back button and can be shared as a link.
// Every field is optional and `.catch`es bad input back to `undefined`, so a
// hand-typed `?page=abc` falls back to the default instead of blowing up
// `validateSearch`.
export const projectSearchSchema = z.object({
  view: z.enum(['list', 'tiles']).optional(),
  tab: z.enum(['my-projects', 'company-projects']).optional(),
  q: z.string().optional().catch(undefined),
  page: z.coerce.number().int().min(0).optional().catch(undefined),
  size: z.coerce.number().int().min(1).max(100).optional().catch(undefined),
  sort: z.string().optional().catch(undefined),
  dir: z.enum(['ASC', 'DESC']).optional().catch(undefined),
  // company projects only: show deactivated projects, and which folder the tile
  // view is currently inside
  inactive: z.boolean().optional().catch(undefined),
  folder: z.string().optional().catch(undefined)
})

export const copyProjectSearchSchema = projectSearchSchema.extend({
  projectId: z.string(),
  parentId: z.string().optional(),
  parentName: z.string().optional(),
  parentParentId: z.string().optional(),
  projectName: z.string().optional()
})

export const createProjectSearchSchema = projectSearchSchema.extend({
  parentId: z.string().optional()
})

export const createFolderSearchSchema = projectSearchSchema.extend({
  parentId: z.string().optional()
})

export const renameSearchSchema = projectSearchSchema.extend({
  id: z.string().optional()
})

export const infoSearchSchema = projectSearchSchema

export const moveFolderSearchSchema = projectSearchSchema

export const moveProjectSearchSchema = projectSearchSchema

export const settingsSearchSchema = projectSearchSchema
